import React from 'react';
import { Query } from 'react-apollo';
import { Typography, Icon } from '@material-ui/core';
import { FusePageCarded } from '../../../../@fuse';
import { AI_RULES } from '../../../../graphql/query';
import TestQuery from './components/TestQuery';
import RulesTable from './components/RulesTable';
import { requireAuthentication } from '../../../../auth';
import UploadExcel from './components/UploadExcel';

class AiPage extends React.Component {
  render() {
    const header = (
      <div className="flex items-center p-8 md:p-24">
        <Icon className="text-32 mr-12">chat_bubble_outline</Icon>
        <Typography variant="title">AI Setting</Typography>
      </div>
    );
    const content = (
      <div style={{ padding: '24px' }}>
        <TestQuery />
        <UploadExcel />
        <Query query={AI_RULES}>
          {({ loading, error, data: { aiRules } }) => {
            return <RulesTable aiRules={aiRules} />;
          }}
        </Query>
      </div>
    );
    return <FusePageCarded header={header} content={content} innerScroll />;
  }
}

export default requireAuthentication(AiPage);



// WEBPACK FOOTER //
// ./src/main/content/project/ai/index.js